import * as z from 'zod';
import { zFirstName, zLastName, zEmail } from './error-messages';

export const signUpFormSchema = z.object({
  firstName: zFirstName,
  lastName: zLastName,
  email: zEmail,
  captchaToken: z.string().optional(),
});

export type SignUpFormData = z.TypeOf<typeof signUpFormSchema>;
